import jQuery from 'jquery';
let $ = jQuery;

var HSN = window.HSN || {};

HSN.Metrics = (function ($) {
  "use strict";

  window.console = window.console || {};

  var metricsUrl = "/api/metrics/";

  function publicSend(hitType, fieldObject) {
    if (!hitType || !fieldObject || fieldObject.length === 0) {
      return;
    }

    $.ajax({
      type: "POST",
      url: metricsUrl + hitType,
      data: fieldObject
    });
  }

  function publicSendEvent(category, action, label, value, fieldObject) {
    if (!category || !action) {
      return;
    }
    
    var data = {
      "category": category,
      "action": action,
      "label": label,
      "value": value,
      "optFieldsJson": JSON.stringify(fieldObject)
    };

    publicSend('event', data);
  }

  function publicSendPageview(type, name, fieldObject) {
    var data = {
      "url": window.location.protocol + '//' + window.location.hostname + window.location.pathname + window.location.search,
      "pageType": type || "other",
      "pageName": name || (window.location.pathname + window.location.search),
      "optFieldsJson": JSON.stringify(fieldObject)
    };

    publicSend('pageview', data);
  }

  return {
    send: publicSend,
    sendEvent: publicSendEvent,
    sendPageview: publicSendPageview
  }
})(jQuery);



// WEBPACK FOOTER //
// ./assets/js/HSN/Metrics.js